export default function NavigateLink({onClick, children}) {
    const OnClick = (e) => {
        e.preventDefault();
        onClick();
    }

    return (
        <a href="#" onClick={OnClick}>{children}</a>
    )
}